import Vue from 'vue';
import request from '@/utils/request';
import polyline from 'polyline-encoded';
import config from '../../../config.json';

export default {
    createOrder: async ({dispatch}, data) => {
        await request({
            method: 'post', url: '/orders', headers: {
                authorization: config.createOrderAuth
            }, data
        })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        status: 'error',
                        message: error.response.data.error,
                        locale: true
                    }, {root: true});
                }
            });
    },

    // eslint-disable-next-line no-unused-vars
    setOrderToWait: async ({dispatch}, orderId) => {
        if (!orderId) return null;

        return await request({method: 'post', url: `/orders/${orderId}/setOrderToWait`}).then(res => {
            return res.status == 200;
        }).catch(() => null);
    },

    async assignDriver(store, {orderId, callSign}) {
        if (!orderId || !callSign) return null;

        return await request({
            method: 'post', url: `/orders/${orderId}/assign`, data: {
                callSign
            }
        }).then(res => {
            return res.status === 200;
        }).catch(() => null);
    },

    async delegateAllToOperator(store, operatorId) {
        if (!operatorId) return null;

        return await request({method: 'patch', url: `/orders-delivery/delegate/${operatorId}`}).catch(() => null);
    },

    // eslint-disable-next-line no-unused-vars
    autocompleteAdress: async ({dispatch, commit}, addressValue) => {
        await request({
            method: 'get', url: `/orders/complete/addresses`, params: {
                q: addressValue
            }
        })
            .then((res) => {
                commit('SET_AUTOCOMPLETE_ADRESSES', res.data);
            });
    },

    // eslint-disable-next-line no-unused-vars
    forcedOrder: async ({commit}, order) => {
        await request({method: 'post', url: `/orders/${order.orderId}/forcedOrder`, data: {driverId: order.driverId}});
    },

    // eslint-disable-next-line no-unused-vars
    editOrder: async ({commit}, {orderId, isDelivery}) => {
        if (!orderId) return null;

        return await request({method: 'post', url: `/orders/${orderId}/${isDelivery ? 'makeActive' : 'editOrder'}`})
            .then(res => res.status === 200 && res.data)
            .catch(null);
    },

    // eslint-disable-next-line no-unused-vars
    saveOrder: async ({commit}, orderData) => {
        return await request({method: 'post', url: `/orders/${orderData.id}/updateAcceptedOrder`, data: {...orderData}})
            .then(res => res.status == 200)
            .catch(() => null);
    },

    // eslint-disable-next-line no-unused-vars
    waitOrder: async ({dispatch, commit}, orderId) => {
        return await request({method: 'post', url: `/orders/${orderId}/wait`})
            .then(res => res.status == 200)
            .catch(() => null);
    },

    // eslint-disable-next-line no-unused-vars
    searchOrder: async ({dispatch, commit}, orderData) => {
        if (!orderData.id) return null;

        return await request({method: 'post', url: `/orders/${orderData.id}/startSearch`, data: {...orderData}})
            .then(res => res.status == 200)
            .catch(() => null);
    },

    // eslint-disable-next-line no-unused-vars
    returnToSearch: async ({dispatch, commit}, orderId) => {
        if (!orderId) return null;

        return await request({method: 'post', url: `/orders/${orderId}/return-to-search`})
            .then(res => res.status == 200)
            .catch(() => null);
    },

    // eslint-disable-next-line no-unused-vars
    cancelOrder: async ({dispatch, commit}, data) => {
        if (!data.id) return null;

        return await request({
            method: 'post',
            url: `/orders/${data.id}/cancel`,
            data
        })
            .then(res => res.status == 200)
            .catch(error => {
                if (error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        status: 'error',
                        message: error.response.data.error,
                        locale: true
                    }, {root: true});
                }
            });
    },

    getOrderHistory: async ({commit}, orderId) => {
        if (!orderId) return null;

        await request({method: 'get', url: `/orders/statusesHistory/${orderId}`})
            .then(res => {
                commit('SET_ORDER_HISTORIES', res.data);
            });
    },

    getClientStatusesHistory: async ({commit}, phoneNumber) => {
        if (!phoneNumber) return null;

        await request({method: 'get', url: `/orders/statusesHistory/client/${phoneNumber}`})
            .then(res => {
                commit('SET_CLIENT_STATUSES_HISTORY', res.data);
            });
    },

    getOrderDrivers: async ({commit}, orderId) => {
        await request({method: 'get', url: `/orders/${orderId}/drivers`})
            .then(res => {
                commit('SET_ORDER_DRIVERS', res.data);
                commit('SET_FILTERED_ORDER_DRIVERS', res.data);
            });
    },

    // eslint-disable-next-line no-unused-vars
    updateOrder: async ({commit}, orderData) => {
        return await request({method: 'post', url: `/orders/${orderData.id}`, data: {...orderData}})
            .then(res => res.status == 200 && res.data)
            .catch(() => null);
    },

    // eslint-disable-next-line no-unused-vars
    makeActiveOrder: async ({commit}, orderId) => {
        return await request({method: 'post', url: `/orders/${orderId}/makeActive`})
            .then(res => res.status == 200)
            .catch(() => null);
    },

    getBrandDetails: async ({commit}) => {
        await request({method: 'get', url: `/admin/settings/public`})
            .then(res => {
                commit('SET_BRAND_DETAILS', res.data);
            });
    },

    // eslint-disable-next-line no-unused-vars
    duplicateOrder: async ({commit}, orderData) => {
        await request({method: 'post', url: `/orders/${orderData.id}/makeDuplicate`});
    },

    // eslint-disable-next-line no-unused-vars
    hideOrder: async ({commit}, orderId) => {
        await request({method: 'post', url: `/orders/${orderId}/hideOrder`});
    },

    getCoordinates: async ({commit}, orderData) => {
        return await request({method: 'post', url: `/orders/${orderData.id}/calculateRoute`, data: {...orderData}})
            .then(res => {
                if (res.status == 200) {
                    commit('SET_POLYLINE', polyline.decode(res.data.routeInfo && res.data.routeInfo.routes[0] && res.data.routeInfo.routes[0].geometry || [], 6));
                    commit('SET_COORDINATES', res.data.coords);
                    commit('CLEAR_ADDRESS_COORDS');

                    return res.data;
                }
            }).catch(() => null);
    },

    getAllOrders: async ({commit}, orderId) => {
        await request({method: 'get', url: '/orders/all', params: {orderId}})
            .then(res => {
                commit('SET_ALL_ORDERS', res.data);
            });
    },

    getGroupOrdersCoords: async ({commit}, filters) => {
        await request({method: 'get', url: 'admin/orders/coords', params: {...filters}})
            .then(res => {
                commit('SET_GROUP_ORDERS_COORDS', res.data);
            });
    },

    // eslint-disable-next-line no-unused-vars
    getOrderData: async ({commit}, orderId) => {
        return await request({method: 'get', url: `/orders/${orderId}/data`}).then(res => {
            if (res.status == 200) {
                const data = res.data;
                const addresses = res.data.unorderedAddresses
                    .sortBy('sortOrder')
                    .map('place')
                    .map(it => Vue.filter('extendAddress')(it));

                const preparedData = {addresses};
                const establishment = res.data.establishment;
                if (establishment && establishment.place) {
                    preparedData.establishment = {
                        ...establishment, place: Vue.filter('extendAddress')(establishment.place)
                    };
                }

                return Object.assign({}, Object.reject(data, ['unorderedAddresses']), preparedData);
            } else {
                return null;
            }
        }).catch(() => null);
    }
};
